// extracted by mini-css-extract-plugin
module.exports = {"cornerButton":"_aea2359","infoIconMobile":"_9c72b5c","withJackpot":"_828c9b0","fav":"_5e16c63","touch":"_0339bcc","activated":"_3d4d739","info":"_83805b3"};